import React, { useEffect, useRef, useState } from "react";
import { Modal, ModalHeader, ModalBody, Row, Col } from "reactstrap";
import gameimg1 from "../../assets/kangaroo/gamestep1.png";
import gameimg2 from "../../assets/kangaroo/gamestep2.png";
import gameimg3 from "../../assets/kangaroo/gamestep3.png";
import gameimg4 from "../../assets/kangaroo/gamestep4.png";
import img1 from "../../assets/kangaroo/sydney types.png";
import img2 from "../../assets/kangaroo/tower types.png";
import img3 from "../../assets/kangaroo/smthg clock tpes.png";
import img4 from "../../assets/kangaroo/usa types.png";
import img5 from "../../assets/kangaroo/canada types.png";
import img6 from "../../assets/kangaroo/yesno.png";

import { X } from "lucide-react";
import Smallbutton from "../button/Smallbutton";

import Fullform from "../FullForm/Fullform";
import Destinationcountry from "../../services/Destinationcountry";
import toast from "react-hot-toast";
import FormService from "../../services/FormService";
import "./MultiForm.css";

const MultiStepForm = ({ isOpen, toggleModal, formOrigin }) => {
  const [open,setOpen] = useState(isOpen);
   useEffect(() => {
    setOpen(isOpen);
  }, [isOpen]);
  const closeAllModals = () => {
    setOpen(false);
    setModalTwo(false);
    setModalThree(false);
    setModalFour(false);
    setModalFive(false);
    setModalSix(false);
  };
  const closeBtn = (
    <div className="w-100 d-flex justify-content-end">
      <button className="close-btn " onClick={closeAllModals}>
        <X color="gray" />
      </button>
    </div>
  );
  const images = [
    { src: img1 },
    { src: img2 },
    { src: img3 },
    { src: img4 },
    { src: img5 },
    { src: img6 },
  ];

  const [countryData, setCountryData] = useState([]);
  const fetchCountry = async () => {
    try {
      const response = await Destinationcountry.getList();
      setCountryData(response);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchCountry();
  }, []);

  const fields = [
    "Business & Management",
    "IT & Computing",
    "Health & Nursing",
    "Engineering",
    "Arts & Design",
    "Hospitality",
    "Others",
  ];

  const questions = [
    "I want counseling and course suggestions",
    "I need help with documentation and visa",
    "I want to join test preparation classes",
    "I'm exploring study options for later",
  ];

  const time = [
    "Within 3 Months",
    "In 6 - 12 Months",
    "Next Year",
    "Just Exploring for Now",
  ];

  const [selectedCountry, setSelectedCountry] = useState(null);
  const[isMobile,setIsMobile] = useState(window.innerWidth < 768);

  const [selectedCourse, setSelectedCourse] = useState(null);
  const [selectedTime, setSelectedTime] = useState(null);
  const [selectedHelp, setSelectedHelp] = useState(null);

  const [modalTwo, setModalTwo] = useState(false);
  const toggleModalTwo = () => setModalTwo((prev) => !prev);

  const [modalThree, setModalThree] = useState(false);
  const toggleModalThree = () => setModalThree((prev) => !prev);

  const [modalFour, setModalFour] = useState(false);
  const toggleModalFour = () => setModalFour((prev) => !prev);

  const [modalFive, setModalFive] = useState(false);
  const toggleModalFive = () => setModalFive((prev) => !prev);

  const [modalSix, setModalSix] = useState(false);
  const toggleModalSix = () => setModalSix((prev) => !prev);
  console.log("asd", countryData);
  const handleSubmit = async (formValues) => {
    console.log("🚀 ~ handleSubmit ~ formValues:", formValues);
    console.log("🚀 ~ handleSubmit ~ selectedCountry:", selectedCountry);
    console.log("🚀 ~ handleSubmit ~ selectedCourse:", selectedCourse);
    try {
      const payload = {
        fullName: formValues.fullName,
        email: formValues.email,
        phone: formValues.phone,
        nationality: formValues.nationality || "",
        currentQualification: formValues.currentQualification || "",
        intendedLevel: formValues.intendedLevel || "",
        preferredCountryId: selectedCountry?.id || "", // ← Use passed value
        // preferedBranchId: formValues.preferedBranchId || "",
        preferredCourse: selectedCourse || "", // ← Use passed value
        budgetRange: formValues.budgetRange || "",
        englishLevel: formValues.englishLevel || "",
        workExperienceYears: formValues.workExperienceYears || 0,
        message: formValues.message || "",
        consent: formValues.consent || false,
        leadSource: "KEF Game Form",
        applyTime: selectedTime,
        helpNeeded: selectedHelp,
        formOrigin: formOrigin,
      };
      console.log("🚀 ~ handleSubmit ~ payload:", payload);

      await FormService.create(payload);

 
    } catch (error) {
      console.error(error);
    }
  };
  return (
    <>
      {/* first modal */}

      <Modal
        isOpen={open}
        toggle={toggleModal}
        onClosed={() => {
          console.log("Modal closed"); // your data here
        }}
        size="lg"
        backdrop="static"
        keyboard={false} // Escape key won’t close
      >
        <ModalHeader
          toggle={toggleModal}
          style={{ borderBottom: "0px" }}
          close={closeBtn}
        ></ModalHeader>

        <ModalBody className="p-0">
          {/* Content Section */}
          <div className="py-4 " style={{ marginLeft: "4rem" }}>
            <Row>
              <Col>
                <h1 className="game-font lh-1">
                  HI! I'M SMART <br /> KANGAROO,
                </h1>
                <p className="game-subtext-font lh-1">
                  here to help you choose the <br /> best study destination
                </p>
                <p className="game-desc-font">
                  Let's find the best study destination for you in less <br />{" "}
                  than 30 seconds!
                </p>
              </Col>
            </Row>
            <Row>
              <Col className="mt-4">
                <div
                  onClick={() => {
                    toggleModalTwo();
                    toggleModal();
                  }}
                >
                  <Smallbutton text="BEGIN" />
                </div>
              </Col>
            </Row>
          </div>

          {/* Bottom Image Section */}
          <div
            style={{
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "flex-end",
              width: "100%",
              marginTop: "20px",
              padding: "0px",
              // spacing from content
            }}
          >
            <img
              src={gameimg1}
              loading="lazy"
              alt=""
              style={{
                width: "550px", // adjust size
                height: "auto",
              }}
            />
          </div>
        </ModalBody>
      </Modal>

      {/* Second Modal */}

      <Modal
        isOpen={modalTwo}
        toggle={toggleModalTwo}
        size="lg"
        backdrop="static"
        keyboard={false} // Escape key won’t close
      >
        <ModalHeader
          toggle={toggleModalTwo}
          style={{ borderBottom: "0px" }}
          close={closeBtn}
        ></ModalHeader>

        <ModalBody className="p-0">
          {/* Content Section */}
          <div className="" style={{ marginLeft: "4rem", marginRight: "4rem" }}>
            <Row>
              <Col>
                <h1 className="font-level-4 lh-1">
                  WHERE DO YOU <br /> WANT TO STUDY?
                </h1>
              </Col>
            </Row>
            <Row className="mt-4">
              {countryData?.map((item, index) => {
                const image = images[index] || {}; // get static image data
                const isSelected = selectedCountry?.id === item?.id;

                return (
                  <Col xs={12} key={index}>
                    <hr style={{ borderTop: "1.5px solid #5c5858" }} />
                    <div
                      className="d-flex align-items-center m-0"
                      style={{ cursor: "pointer" }}
                      onClick={() =>
                        setSelectedCountry({
                          id: item?.id, // pass country id
                          name: item?.name, // optional, for easy access
                          src: image?.src, // the image
                        })
                      }
                    >
                      {/* Radio Button */}
                      <input
                        type="radio"
                        name="imageOption"
                        id={`img-${index}`}
                        checked={isSelected}
                        onChange={() =>
                          setSelectedCountry({
                            id: item.id,
                            name: item.name,
                            src: image.src,
                          })
                        }
                        className="form-check-input flex-shrink-0"
                        style={{
                          width: "28px",
                          height: "28px",
                          marginRight: "20px",
                          border: "1px solid #5c5858",
                        }}
                      />

                      {/* Image */}
                      <img
                        src={image.src}
                        alt={image.title}
                        style={{
                          width: "54px",
                          objectFit: "cover",
                          borderRadius: "12px",
                        }}
                      />

                      {/* Title */}
                      <div className="ms-4 flex-grow-1">
                        <h5
                          style={{
                            margin: 0,
                            fontWeight: isSelected ? "700" : "600",
                            fontSize: "1.25rem",
                          }}
                        >
                          {item.name}
                        </h5>
                      </div>
                    </div>
                  </Col>
                );
              })}

              {/* NOT SURE YET Option */}
              <Col xs={12}>
                <hr style={{ borderTop: "1.5px solid #5c5858" }} />
                <div
                  className="d-flex align-items-center m-0"
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    setSelectedCountry({
                      id: null,
                      name: "notsure",
                      src: img6,
                      url: null,
                    })
                  }
                >
                  {/* Radio Button */}
                  <input
                    type="radio"
                    name="imageOption"
                    id="notsure"
                    checked={selectedCountry?.name === "notsure"}
                    onChange={() =>
                      setSelectedCountry({
                        id: null,
                        name: "notsure",
                        src: img6,
                        url: null,
                      })
                    }
                    className="form-check-input flex-shrink-0"
                    style={{
                      width: "28px",
                      height: "28px",
                      marginRight: "20px",
                      border: "1px solid #5c5858",
                    }}
                  />

                  {/* Image */}
                  <img
                    src={img6}
                    alt="NOT SURE"
                    style={{
                      width: "54px",
                      objectFit: "cover",
                      borderRadius: "12px",
                    }}
                  />

                  {/* Title */}
                  <div className="ms-4 flex-grow-1">
                    <h5
                      style={{
                        margin: 0,
                        fontWeight:
                          selectedCountry?.name === "notsure" ? "700" : "600",
                        fontSize: "1.25rem",
                      }}
                    >
                      NOT SURE YET
                    </h5>
                  </div>
                </div>
              </Col>
            </Row>
            {isMobile === true &&(<Row>
                <Col className="mt-4">
                  <div
                    onClick={() => {
                      if(!selectedCountry){
                        toast.error("Please select an option");
                        return;
                      }
                      toggleModalTwo();
                      toggleModalThree();
                    }}
                  >
                    <Smallbutton text="NEXT"  widthPercentage="70%"/>
                  </div>
                </Col>
              </Row>)}

            <div className="d-flex jusitfy-content-center align-items-center">
              {isMobile === false &&(<Row>
                <Col className="mt-4">
                  <div
                    onClick={() => {
                       if(!selectedCountry){
                        toast.error("Please select an option");
                        return;
                      }
                      toggleModalTwo();
                      toggleModalThree();
                    }}
                  >
                    <Smallbutton text="NEXT" />
                  </div>
                </Col>
              </Row>)}
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "flex-end",
                  width: "100%",
                  marginTop: "20px",
                  padding: "0px",
                  // spacing from content
                }}
              >
                <img
                  src={gameimg2}
                  alt=""
                  fluid
                  style={{
                    width: "80vw", // adjust size
                    maxWidth: "550px", // adjust size
                    height: "auto",
                    marginLeft: "2.7rem",
                  }}
                />
                {/* <img
                  src={gameimg2}
                  alt=""
                  fluid
                  className="img-fluid ms-auto"
                  style={{
                    width: "10vw",        // responsive
                    maxWidth: "550px",    // desktop limit
                    height: "auto",
                    margin: "6.7rem",       // keep ratio, // keeps your spacing
                  }}
                /> */}
              </div>
            </div>
          </div>
        </ModalBody>
      </Modal>

      {/* Third Modal */}

      <Modal
        isOpen={modalThree}
        toggle={toggleModalThree}
        size="lg"
        backdrop="static"
        keyboard={false} // Escape key won’t close
      >
        <ModalHeader
          toggle={toggleModalThree}
          style={{ borderBottom: "0px" }}
          close={closeBtn}
        ></ModalHeader>

        <ModalBody className="p-0">
          {/* Content Section */}
          <div
            className="py-4 "
            style={{ marginLeft: "4rem", marginRight: "4rem" }}
          >
            <Row>
              <Col>
                <h1 className="font-level-4 lh-1">
                  WHAT'S YOUR FIELD <br />
                  OF INTEREST?
                </h1>
              </Col>
            </Row>
            <Row className="mt-4">
              {fields.map((field, index) => {
                const isSelected = selectedCourse === field;

                return (
                  <Col xs={12} key={index}>
                    <hr
                      style={{ borderTop: "1.5px solid #5c5858", margin: "0" }}
                    />

                    <div
                      className="d-flex align-items-center py-4 px-3"
                      style={{
                        cursor: "pointer",
                      }}
                      onClick={() => setSelectedCourse(field)}
                    >
                      {/* Radio Button */}
                      <input
                        type="radio"
                        name="fieldOption"
                        checked={isSelected}
                        onChange={() => setSelectedCourse(field)}
                        className="form-check-input flex-shrink-0"
                        style={{
                          width: "28px",
                          height: "28px",
                          marginRight: "20px",
                          border: "1px solid #5c5858",
                        }}
                      />

                      {/* Field Title */}
                      <label
                        htmlFor={`field-${index}`}
                        className="w-100"
                        style={{
                          margin: 0,
                          fontSize: "1.25rem",
                          fontWeight: isSelected ? "700" : "500",
                          cursor: "pointer",
                          transition: "all 0.3s ease",
                        }}
                      >
                        {field}
                      </label>
                    </div>
                  </Col>
                );
              })}
            </Row>
            <div className="d-flex jusitfy-content-center align-items-center">
              <Row>
                <Col style={{ marginTop: "5.5rem", marginBottom: "5.5rem" }}>
                  <div
                    onClick={() => {
                      if(!selectedCourse){
                        toast.error("Please select an option");
                        return;
                      }
                      toggleModalThree();
                      toggleModalFour();
                    }}
                  >
                    <Smallbutton text="NEXT" widthPercentage="70%" />
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        </ModalBody>
      </Modal>

      {/* Fourth Modal */}
      <Modal
        isOpen={modalFour}
        toggle={toggleModalFour}
        size="lg"
        backdrop="static"
        keyboard={false} // Escape key won’t close
        closeOnOutsideClick={false}
        closeOnBlur={false}
         className="tall-modal"
      >
        <ModalHeader
          toggle={toggleModalFour}
          style={{ borderBottom: "0px" }}
          close={closeBtn}
        ></ModalHeader>

        <ModalBody className="p-0">
          {/* Content Section */}
          <div className="" style={{ marginLeft: "4rem" }}>
            <Row>
              <Col>
                <h1 className="font-level-4 lh-1">
                  WHEN DO YOU <br /> PLAN TO APPLY?
                </h1>
              </Col>
            </Row>

            <div className="d-flex justify-content-between align-items-start">
              {/* Left side - Radio options */}
              <div style={{ flex: "0 0 50%" }}>
                <Row className="mt-4">
                  {time.map((field, index) => {
                    const isSelected = selectedTime === index;

                    return (
                      <Col xs={12} key={index}>
                        <hr
                          style={{
                            borderTop: "1.5px solid #5c5858",
                            margin: "0",
                          }}
                        />

                        <div
                          className="d-flex align-items-center py-4 px-3"
                          style={{
                            cursor: "pointer",
                          }}
                          onClick={() => setSelectedTime(index)}
                        >
                          {/* Radio Button */}
                          <input
                            type="radio"
                            name="fieldOption"
                            checked={isSelected}
                            onChange={() => setSelectedTime(index)}
                            className="form-check-input flex-shrink-0"
                            style={{
                              width: "28px",
                              height: "28px",
                              marginRight: "20px",
                              border: "1px solid #5c5858",
                            }}
                          />

                          {/* Field Title */}
                          <label
                            htmlFor={`field-${index}`}
                            className="w-100"
                            style={{
                              margin: 0,
                              fontSize: "1.25rem",
                              fontWeight: isSelected ? "700" : "500",
                              cursor: "pointer",
                              transition: "all 0.3s ease",
                            }}
                          >
                            {field}
                          </label>
                        </div>
                      </Col>
                    );
                  })}
                </Row>
                 <Row className="mt-5 mb-5 pb-5">
              <Col>
                <div onClick={() => {
                  if(!selectedTime){
                    toast.error("Please select an option");
                    return;
                  }
                  toggleModalFour(); toggleModalFive(); }}>
                  <Smallbutton text="NEXT" widthPercentage="100%" />
                </div>
              </Col>
            </Row>
              </div>

              <div
                className="d-flex justify-content-end align-items-end "
                style={{ flex: "0 0 40%" }}
              >
                <img src={gameimg3} alt="" className=" position-absolute bottom-0" style={{ width: "50vw", minWidth: "180px", maxWidth: "280px", marginTop: "100px" }} />
              </div>
            </div>
          </div>
        </ModalBody>
      </Modal>

      {/* Fifth Modal */}

      <Modal
        isOpen={modalFive}
        toggle={toggleModalFive}
        size="lg"
        backdrop="static"
        keyboard={false} // Escape key won’t close
        closeOnOutsideClick={false}
        closeOnBlur={false}
      >
        <ModalHeader
          toggle={toggleModalFive}
          style={{ borderBottom: "0px" }}
          close={closeBtn}
        ></ModalHeader>

        <ModalBody className="p-0 ">
          {/* Content Section */}
          <div className="pt-4" style={{ marginLeft: "4rem" }}>
            <Row>
              <Col>
                <h1 className="font-level-4 lh-1">
                  HOW CAN KEF HELP YOU MOST RIGHT <br /> NOW?
                </h1>
              </Col>
            </Row>

            <Row className="mt-4">
              {questions.map((field, index) => {
                const isSelected = selectedHelp === field;

                return (
                  <Col xs={12} key={index} style={{ paddingRight: "4rem" }}>
                    <hr
                      style={{ borderTop: "1.5px solid #5c5858", margin: "0" }}
                    />

                    <div
                      className="d-flex align-items-center py-4 px-3"
                      style={{
                        cursor: "pointer",
                      }}
                      onClick={() => setSelectedHelp(field)}
                    >
                      {/* Radio Button */}
                      <input
                        type="radio"
                        name="fieldOption"
                        checked={isSelected}
                        onChange={() => setSelectedHelp(field)}
                        className="form-check-input flex-shrink-0"
                        style={{
                          width: "28px",
                          height: "28px",
                          marginRight: "20px",
                          border: "1px solid #5c5858",
                        }}
                      />

                      {/* Field Title */}
                      <label
                        htmlFor={`field-${index}`}
                        className="w-100"
                        style={{
                          margin: 0,
                          fontSize: "1.25rem",
                          fontWeight: isSelected ? "700" : "500",
                          cursor: "pointer",
                          transition: "all 0.3s ease",
                        }}
                      >
                        {field}
                      </label>
                    </div>
                  </Col>
                );
              })}
            </Row>
             {isMobile === true &&( <Row>
                <Col className="mt-4">
                  <div
                    onClick={() => {
                      if(!selectedHelp){
                        toast.error("Please select an option");
                        return;
                      }
                      toggleModalFive();
                      toggleModalSix();
                    }}
                  >
                    <Smallbutton text="NEXT" />
                  </div>
                </Col>
              </Row>)}

            <div className="d-flex justify-content-between align-items-center mt-4 ">
             {isMobile === false &&( <Row>
                <Col className="mt-4">
                  <div
                    onClick={() => {
                      if(!selectedHelp){
                        toast.error("Please select an option");
                        return;
                      }
                      toggleModalFive();
                      toggleModalSix();
                    }}
                  >
                    <Smallbutton text="NEXT" />
                  </div>
                </Col>
              </Row>)}
              <img
                src={gameimg4}
                alt=""
                style={{
                  maxWidth: "100%",
                  width: "400px",
                  height: "auto",
                }}
              />
            </div>
          </div>
        </ModalBody>
      </Modal>

      {/* Sixth Modal */}

      <Modal
        isOpen={modalSix}
        toggle={toggleModalSix}
        size="lg"
        backdrop="static"
        keyboard={false} // Escape key won’t close
        closeOnOutsideClick={false}
        closeOnBlur={false}
      >
        <ModalHeader
          toggle={() => {
            toggleModalSix();
            closeAllModals();
          }}
          style={{ borderBottom: "0px" }}
          close={closeBtn}
        ></ModalHeader>
        <ModalBody className="p-0">
          <div
            className="py-4"
            style={{ marginLeft: "4rem", marginRight: "4rem" }}
          >
            <Row>
              <Col>
                <h1 className="font-level-4 lh-1">
                  YOU'RE READY TO <br /> START SMART WITH KEF!
                </h1>
                <p className="game-desc-font lh-1">
                  Share your details to receive your personalized <br /> study
                  plan and speak with a counselor.
                </p>
              </Col>
            </Row>
            <Fullform
              fullName={true}
              email={true}
              phone={true}
              message={true}
              gameClose={true}
              closeAllModals={closeAllModals}
              onSubmit={handleSubmit}
              selectedCountry={selectedCountry} // ← Add this
              selectedCourse={selectedCourse} // ← Add this
              isBanner={true}
              formOrigin={formOrigin}
            />
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

export default MultiStepForm;
